export default __webpack_public_path__ + "img/check-dark.6406a127.svg";